import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import WelcomeInfoRow from "./WelcomeInfoRow";
import SchemasWidget from '../../components/widgets/schemas/SchemasWidget';
import LicenseWidget from '../../components/widgets/license/LicenseWidget';
import ContentBlocker from "../../components/context/ContentBlocker";
import ActiveSchemaWidget from "../../components/widgets/active-schema/ActiveSchemaWidget";
import {SchemaContextProvider} from "../../components/schema/context/SchemaContext";

import './HomePage.scss';

/**
 * Default page when visiting the workbench.
 */
class HomePage extends React.Component {

  render() {
    return (
      <div className="HomePage">
        <h1>Workbench</h1>
        <WelcomeInfoRow/>
        <ContentBlocker renderLicenseAlert={false} checkReadPermission={true}>
          <SchemaContextProvider>
            <ActiveSchemaWidget/>
            <Row>
              <Col>
                <SchemasWidget/>
              </Col>
            </Row>
          </SchemaContextProvider>
        </ContentBlocker>
        <Row>
          <Col>
            <LicenseWidget/>
          </Col>
        </Row>
      </div>
    );
  }
}

export default HomePage;
